<script lang="ts">
	import { scale, slide } from 'svelte/transition';
	import ArrowRightIcon from '../../icons/ArrowRightIcon.svelte';
	import { AutoResizeTextarea } from '../../common/TextAreaAutoSize';

	export let inputRef: HTMLTextAreaElement | null = null;
	export let handleSendMessage: () => void;
	export let inputValue: string;
	export let showStopGenerateButton: boolean;

	let isFocus: boolean = false;

	const onKeyPress = (e: KeyboardEvent) => {
		if (
			(e as KeyboardEvent).key === 'Enter' &&
			!(e as KeyboardEvent).shiftKey &&
			inputValue.trim() &&
			!showStopGenerateButton
		) {
			e.preventDefault();
			handleSendMessage();
		}
	};

	const onFocus = () => {
		isFocus = true;
	};

	const onBlur = () => {
		isFocus = false;
	};
</script>
<div class="chat-input-wrapper">
	<div
		class="input-block"
		class:focus={isFocus}
		in:scale={{ duration: 200 }}
	>
		<div class="top">
			<AutoResizeTextarea
				bind:value={inputValue}
				bind:ref={inputRef}
				minRows={1}
				maxRows={4}
				{onKeyPress}
				{onFocus}
				{onBlur}
				placeholder="Ask anything"
				withButton={true}
				demoInput
			/>
			{#if inputValue}
				<button class="send-button" on:click={handleSendMessage}>
					<ArrowRightIcon />
				</button>
			{/if}
		</div>
	</div>
</div>

<style lang="scss">
	.chat-input-wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		max-width: 800px;
		gap: 10px;
		padding: 0 16px;
	}
	.input-block {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		border: 1px solid var(--button-border-color);
		border-radius: 10px;
		background-color: var(--chat-input-bg);
		backdrop-filter: blur(6px);
		-webkit-backdrop-filter: blur(6px);
		transition: 200ms;
		font-weight: 300;
		position: relative;

		.send-button {
			width: 34px;
			height: 34px;
			position: absolute;
			background: var(--button-bg);
			right: 10px;
			top: calc(50% - 17px);
			border: 1px var(--button-border-color) solid;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			color: var(--send-icon-color);
		}
		.top {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}
	.focus {
		border: 1px solid #504df3;
		box-shadow: inset 0 0 4px 0 #504df3, 0 0 4px 0 #504df3;
		transition: 100ms;
	}
</style>